<template>
  <div class="app-footer">
    <p>
      &copy; 2025 Crossroad Credit. All rights reserved.
      &bull; v{{ version }}
      <span v-if="isPreview" class="app-footer__preview"> (preview)</span>
    </p>
  </div>
</template>

<script setup lang="ts">
const version = import.meta.env.VITE_APP_VERSION ?? '0.0.0-local'
const isPreview = version.includes('-')
</script>

<style scoped>
.app-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  color: var(--el-text-color-secondary);
}

.app-footer__preview {
  font-size: 0.9em;
  opacity: 0.9;
}
</style>


